<template>
    <div v-if="reportModel">
        <div class="print-header">BRFSS Logistic Regression</div>
        <h3 class="visually-hidden">BRFSS Logistic Regression</h3>
        <app-navigator
            ref="appNavigator"
            :router="$router"
            :forReport="true"
        ></app-navigator>
        <section-header
            v-if="!isLoading && errorCode == ''"
            ref="select"
            isFor="header"
            :forReport="true"
            :exportXlsx="exportXlsx"
            :allowDownload="!noData"
        ></section-header>
        <div id="brokerResults" v-if="!isLoading && errorCode == ''">
            <no-data-table
                :missingData="reportModel.missingData"
            ></no-data-table>
            <div class="page-break">
                <regression-title
                    ref="title"
                    :selectionModel="selectionModel"
                    :reportModel="reportModel"
                ></regression-title>
                <template v-if="noData">
                    <lr-no-data-table
                        :selectionModel="selectionModel"
                        :reportModel="reportModel"
                        :originalData="originalData"
                    ></lr-no-data-table>
                </template>
                <template v-else>
                    <div class="report-table">
                        <regression-table
                            ref="title"
                            :reportModel="reportModel"
                            minWidth="480px"
                            :independent="independent"
                        ></regression-table>
                    </div>
                    <h4>Model test statistics</h4>
                    <model-test-statistics
                        :reportModel="reportModel.modelTestStatistics"
                        :independentVariables="
                            reportModel.parms.independentVariables
                        "
                    ></model-test-statistics>
                </template>
                <div class="dataset-totals">
                    <dataset-totals
                        :recordTotals="reportModel.recordTotals"
                    ></dataset-totals>
                </div>
                <footnotes :noSourceRecords="noSourceRecords"></footnotes>
            </div>
        </div>
        <div v-if="isLoading">
            <h4>Please wait while report is loading...</h4>
            <div>
                <i class="nccd-spinner-medium margin-auto"></i>
            </div>
        </div>
        <show-errors
            :errorCode="errorCode"
            :errorMessages="errorMessages"
            selectionPath="logisticRegression"
            selectionTitle="Logistic Regression"
        ></show-errors>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off', one-var: 'off', operator-linebreak: 'off', comma-style: 'off' */
import regressionTitle from '@/components/logisticRegression/report/regressionTitle';
import regressionTable from '@/components/logisticRegression/report/regressionTable';
import lrNoDataTable from '@/components/logisticRegression/report/lrNoDataTable';
import modelTestStatistics from '@/components/logisticRegression/report/modelTestStatistics';
import datasetTotals from '@/components/datasetTotals';
import showErrors from '@/components/showErrors';

//import reportModelBuilder from '@/scripts/crossTabulation/reportModelBuilder'
import apiHelper from '@/scripts/logisticRegression/apiHelper';
import common from '@/scripts/common';
import current from '@/scripts/current';
import { mapGetters, mapState } from 'vuex';
import footnotes from '@/components/footnotes';

//import XLSX from 'xlsx-style';
import XLSX from 'xlsx';
import commonModelHelper from '@/scripts/commonModelHelper';
import metricsHelper from '@/scripts/metricsHelper';
import noDataTable from '@/components/noDataTable';
import store from '@/store';
import appNavigator from '@/components/layout/appNavigator';
import sectionHeader from '@/components/sub/sectionHeader';
import xlsxBuilder from '@/scripts/logisticRegression/xlsxBuilder';

export default {
    name: 'viewReport',
    components: {
        regressionTitle,
        regressionTable,
        lrNoDataTable,
        datasetTotals,
        modelTestStatistics,
        showErrors,
        footnotes,
        noDataTable,
        appNavigator,
        sectionHeader
    },
    // setup(props, { attrs, slots, emit, expose }) {
    //     const route = useRoute();
    //     console.log('the route name', route.name);
    //     //console.debug(`current route name on component setup init: ${route.name}`);

    //     // You could use computed property which re-evaluates on route name updates
    //     // const routeName = computed(() => route.name);

    //     // You can watch the property for triggering some other action on change
    //     watch(
    //         () => route.name,
    //         () => {
    //             console.debug(
    //                 `MyCoolComponent - watch route.name changed to ${route.name}`
    //             );
    //             // Do something here...

    //             // Optionally you can set immediate: true config for the watcher to run on init
    //             //}, { immediate: true });
    //         }
    //     );

    //     return { route };
    // },
    computed: {
        route: () => useRoute(),
        // route: function () {
        //     return useRoute();
        // },
        // routeName: function () {
        //     //const route = useRoute();
        //     return route.name;
        // },
        ...mapState({
            isLoading: (state) => state.display.isLoading
        })
    },
    created: function () {
        const vm = this;
        vm.resetClicked = (e) => current.resetClicked(e);
    },
    data: function () {
        var vm = this;
        current.initializeLogisticRegressionValues(vm);
        if (!commonModelHelper.initializeStep(vm, 'viewreport')) return {};

        const results = store.state.results;
        var apiFormData = apiHelper.getReportParameters(current.selectionModel);
        var resultsAlreadyLoaded =
            results.hasData &&
            results.analysisType === 'lr' &&
            results.apiFormData === apiFormData;
        store.dispatch('report/setCountsByStateYear');
        var vmData = buildData();
        metricsHelper.reportRequested();
        if (resultsAlreadyLoaded) {
            apiHelper.populateReportModel(results.data, vmData);
            metricsHelper.reportLoadCached();
        } else
            apiHelper.loadFromApi(
                vmData,
                apiFormData,
                vmData.showUnweighted,
                vm.$router
            );
        vmData.resetClicked = null;
        return vmData;
    },
    mounted: function () {
        this.resizeControls();
    },
    methods: {
        resizeControls: function () {
            var vm = this;
            if (vm.$refs && vm.$refs.myHelp && vm.$refs.myAnalysis) {
                let myAnalysisHeight =
                    vm.$refs.myAnalysis.$refs.subTable.clientHeight;
                if (myAnalysisHeight > 250)
                    vm.$refs.myHelp.$refs.subTable.setAttribute(
                        'style',
                        'max-height: ' + myAnalysisHeight + 'px'
                    );
            }
        },
        getGlyphicon: function (statisticDefinition) {
            switch (statisticDefinition.apiName) {
                case 'sampleSize':
                    return 'glyphicon glyphicon-thumbs-up';
                case 'rowPercentage':
                    return 'glyphicon glyphicon-resize-horizontal';
                case 'columnPercentage':
                    return 'glyphicon glyphicon-resize-vertical';
                case 'totalPercentage':
                    return 'glyphicon glyphicon-fullscreen';
                case 'weightedN':
                    return 'glyphicon glyphicon-scale';
                default:
                    return statisticDefinition.apiName;
            }
        },
        getTableWidth: function (control2) {
            var vm = this;
            var totalStatistics =
                control2.levelsGroupedByRows[
                    control2.levelsGroupedByRows.length - 1
                ].totalStatistics;
            var largestNumber =
                totalStatistics.weightedN !== undefined &&
                totalStatistics.weightedN !== null
                    ? totalStatistics.weightedN.value
                    : totalStatistics.sampleSize;
            var digits = largestNumber.toString().length;
            var numberOfStatisticColumns = control2.levelsGroupedByRows.length;
            var firstColumnWidth = 140;
            var hasCi =
                current.selectionModel.selectedStatistics.confidenceInterval;
            var hasSe = current.selectionModel.selectedStatistics.standardError;
            var statWidth = 40;
            var ciWidth = 120;
            var seWidth = 40;
            var widthForDigit = 20;
            var columnWidth =
                statWidth +
                (statWidth +
                    (hasCi ? ciWidth : 0) +
                    (hasSe ? seWidth : 0) +
                    digits * widthForDigit);
            return firstColumnWidth + numberOfStatisticColumns * columnWidth;
        },
        exportXlsx
    }
};

function exportXlsx(e) {
    const vm = this;
    if (e) e.preventDefault();
    metricsHelper.reportDownloaded();
    let wb = xlsxBuilder.createWorkbook(vm.reportModel, store.state, vm);
    if (wb) XLSX.writeFile(wb, 'sheetjs.xlsx');
}

function buildData() {
    return {
        selectionModel: current.selectionModel,
        modelHelper: current.modelHelper,
        common: common,
        errorCode: '',
        errorMessages: [],
        reportModel: {},
        reportModelNoWeighting: null,
        selectedLevels: {
            control1: [],
            control2: []
        },
        testRow: null,
        testColumn: null,
        showUnweighted: Boolean(
            store.state.selModel.years.selectionType === 'combine'
        ),
        noData: false,
        originalData: {},
        noSourceRecords: false,
        independent: {}
    };
}
</script>

<style scoped="">
.dataset-totals {
    margin-top: 15px;
}

@media screen {
    .print-header {
        display: none;
    }
}

@media print {
    .print-header {
        /*width:250px;*/
        display: inline-block;
        font-size: xx-large;
        margin: 0 0 40px 0px;
        width: 100%;
        text-align: center;
    }
}

@media (min-width: 768px) {
}

@media (max-width: 767px) {
    .report-table {
        overflow-x: auto;
    }

    .sm-top-15 {
        margin-top: 15px;
    }
}

.download-reset-buttons :nth-child(2) {
    float: right;
}

h4 {
    padding-top: 9px;
    font-size: 18px;
    line-height: 28px;
    font-weight: 400;
    margin: 10px 0;
}
</style>
